import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Eye";
const Eye = memo(themed(Icon));
export {
  Eye
};
//# sourceMappingURL=eye.js.map
